import { Avatar, Box, ModalProps, Stack, Typography } from '@mui/material'
// import { t } from 'i18next'
import React from 'react'
import { useTranslation } from 'react-i18next'
import CustomModal from 'src/components/customModal/CustomModal'
import { AVAILABILITY_COLORS } from '../RatesDataGrid.config'

const LegendColorLabel = ({
  children,
  color
}: {
  children: React.ReactNode
  color: string
}) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
      <Avatar
        sx={{
          bgcolor: color
        }}
      >
        {' '}
      </Avatar>
      <Typography>{children}</Typography>
    </Box>
  )
}

const AvailabilityLegendModal: React.FC<Omit<ModalProps, 'children'>> = (
  params
) => {
  const { t } = useTranslation('tarifas')

  return (
    <CustomModal
      {...params}
      boxProps={{
        sx: {
          padding: '2rem'
        }
      }}
    >
      <Stack gap='1rem'>
        <LegendColorLabel color={AVAILABILITY_COLORS.AVAILABLE_BLOCKED.bg}>
          {t('availability_legend.available_blocked')}
        </LegendColorLabel>
        <LegendColorLabel color={AVAILABILITY_COLORS.UNAVAILABLE_BLOCKED.bg}>
          {t('availability_legend.unavailable_blocked')}
        </LegendColorLabel>
        <LegendColorLabel
          color={AVAILABILITY_COLORS.AVAILABLE_OWNER_CHANNEL.bg}
        >
          {t('availability_legend.available_owner')}
        </LegendColorLabel>
        <LegendColorLabel
          color={AVAILABILITY_COLORS.UNAVAILABLE_OWNER_CHANNEL.bg}
        >
          {t('availability_legend.unavailable_owner')}
        </LegendColorLabel>
      </Stack>
    </CustomModal>
  )
}
export default AvailabilityLegendModal
